/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createBoolean } from '../../factoriesAny.js';
export var booleanDependencies = {
  typedDependencies,
  createBoolean
};